/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { App } from 'store/App';
import { ITipCalculator } from 'types';
import * as ActionTypes from './types';

const initialState: ITipCalculator | null = null;

const reducer: Reducer<ITipCalculator | null> = (state = initialState, action): ITipCalculator => {
  switch (action.type) {
    case App.SET_CURRENT_EMPLOYEE_SUCCESS: {
      return initialState;
    }
    case ActionTypes.TipCalculator.GET_POS_SUCCESS: {
      return {
        ...state,
        posResults: action.payload.response,
      };
    }
    case ActionTypes.TipCalculator.UPDATE_CALCULATOR_PAYMENTSET_REQUEST: {
      return {
        ...state,
        paymentSet: action.payload.paymentSet,
      };
    }
    case ActionTypes.TipCalculator.GET_CALCULATED_TIPS_SUCCESS: {
      return {
        ...state,
        results: action.payload.response,
      };
    }
    case ActionTypes.TipCalculator.UPDATE_CALCULATED_TIPS_RESULTS: {
      return {
        ...state,
        results: action.payload.results,
      };
    }
    case ActionTypes.TipCalculator.RESET_CALCULATOR_PAYMENTSET: {
      return {
        ...state,
        paymentSet: undefined,
      };
    }
    case ActionTypes.TipCalculator.SET_CALCULATOR_PAYEES: {
      return {
        ...state,
        payees: action.payload.payees,
      };
    }
    case ActionTypes.TipCalculator.SET_POS_RESULTS: {
      return {
        ...state,
        posResults: action.payload.data,
      };
    }
    case ActionTypes.TipCalculator.SET_CHANGE_LOG_ENTRIES: {
      return {
        ...state,
        changeLog: action.payload.entries,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as tipCalculatorReducer };
